import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtPayOnlyDetermineAmountDrawerCtrl($scope, $timeout, ContentStore) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.getImageUrl = function () {
    return ContentStore.resolveContentImagePath($scope.image);
  };
}

App.controller('LtPayOnlyDetermineAmountDrawerCtrl', [
  '$scope',
  '$timeout',
  'ContentStore',
  LtPayOnlyDetermineAmountDrawerCtrl
]);
